<template>
  <div class="report-wrap">
    <div class=" content">
      <div class="title-wrap dn-content-bg">
        <time-search ref="timeSearch" :control="{data:timeData}" @timeControlChange="timeControlChange" @timeControlClick="TimeControlClick" :showExportBtn="true" :showPrint="true" :showPrintId="'table'" :showPrintTitle="'分类分项报表'" @exportExc="bindExportExc">
        </time-search>
        <div>
        </div>
      </div>
      <div class="table-content  box" style="flex: 1;display: flex;">
        <nk-table id="table" :data="tableData" :noDataTitle="'该时间段暂无数据'" :columns="columns" :showPage="true" :page="page" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
        </nk-table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  findDataByParam,
  dateToColumns,
  toPage,
  exportExcel,
} from "@/utils/index.js";
import NkTable from "@/components/common/NkTable";
import TimeSearch from "@/components/common/TimeSearch.vue";
import tree from '@/utils/tree'
import * as fpg from '@/utils/fpg.js'
import DateTool from '@/utils/dateTool'
let allTimeData = [
  {
    type: "day",
    label: "日",
  },
  {
    type: "month",
    label: "月",
  },
  {
    type: "year",
    label: "年",
  },
];
export default {
  components: { NkTable, TimeSearch },
  data () {
    return {
      timeData: allTimeData,
      selectedDate: {},
      tableData: [],
      columns: [],
      page: {
        pageSizes: [10, 20, 50, 100, 500, 1000], //每页显示条目个数
        size: 10,
        total: 0,
        pageIndex: 1,
      },
      viewId: '',
      enumClass: '',
      expressionName: '',
      unit: ''
    }
  },
  created () {
    let vm = this
    vm.$api.customUrl
      .getMyFrontEndPageCustomParam(vm.$store.state.user.currentCompanyId, "/report/itemizedReport", null)
      .then((res) => {
        res.data.forEach(item => {
          if (item.param == "viewId") {
            vm.viewId = item.value
            let time = new Date();
            let startTime = DateTool.format(time, "yyyy-MM-dd ") + "00:00:00";
            time.setDate(time.getDate() + 1);
            let endTime = DateTool.format(time, "yyyy-MM-dd") + " 00:00:00";

            vm.selectedDate = {
              dataType: "1",
              dateType: "day",
              endTime: endTime,
              startTime: startTime,
            };
            vm.TimeControlClick(vm.selectedDate);
          } else if (item.param == "enumClass") {
            vm.enumClass = item.value
          } else if (item.param == 'expressionName') {
            vm.expressionName = item.value
          } else if (item.param == 'unit') {
            vm.unit = item.value
          }
        })
      });
  },
  mounted () { },
  watch: {},
  methods: {
    timeControlChange () { },
    //查询事件
    TimeControlClick (e) {
      let vm = this;
      vm.selectedDate = e;
      vm.getData(1)
    },
    //获取左边数据
    async getData (pageIndex) {
      let vm = this
      /* 第一步获取自定义视图下的测量点 */
      let res = await vm.$api.view.getViewTreeNodes(vm.viewId)
      let tableData = [];
      let columns = [
        {
          label: "序号",
          fixed: "left",
          show: true,
          width: "100",
          type: 'index',
          align: "center",
        },
        {
          label: "名称",
          show: true,
          prop: "name",
        }
      ];
      if (res.success) {
        let data = res.data;
        let measuresId = []
        let classFilter = []
        let nameData = []
        res.data.forEach(item => {
          measuresId.push(item.measureId)
          tableData.push({
            measureId: item.measureId,
            name: item.measureName
          })
        })
        /* 第二步获取自定义枚举下的子枚举类 */
        let resOne = await vm.$api.enumClass.getSubEnumClasses2(vm.enumClass, 0, this.$store.state.user.currentCompanyId)
        if (resOne.success) {
          resOne.data.forEach(item => {
            columns.push({
              label: item.displayName + '(' + vm.unit + ')',
              show: true,
              prop: item.name,
              align: 'right'
            })
            classFilter.push( /* 拼接求分类分项用量接口参数 */
              [
                {
                  className: vm.enumClass,
                  subclassesName: [item.name]
                }
              ]
            )
            nameData.push(item.name)  /* 放置类对象数据 */
          })
        }
        vm.columns = columns
        let apiName = null
        let dateType = vm.selectedDate.dateType
        if (dateType == "day") {
          apiName = "getQuantityByClassDay2";
        } else if (dateType == "month") {
          apiName = "getQuantityByClassMonth2";
        } else {
          apiName = "getQuantityByClassYear2";
        }
        let resTwo = await vm.$api.quantity[apiName](
          JSON.stringify(measuresId),
          0,
          null,
          JSON.stringify(classFilter),
          vm.expressionName,
          vm.selectedDate.startTime,
          vm.selectedDate.endTime
        )
        resTwo.data.forEach(item => {
          let index = tableData.findIndex(c => c.measureId == item.measureId)
          if (index > -1) {
            item.data[0].values.forEach((k, i) => {
              tableData[index][nameData[i]] = k === null ? '-' : parseFloat(k).toFixed(2)
            })

          }
        })
        let datas = toPage(tableData, pageIndex, vm.page.size);
        vm.page.pageIndex = pageIndex;
        vm.page.total = datas.total;
        vm.tableData = datas.arr
      } else {
        vm.$message.error(res.msg)
      }
    },
    bindExportExc () {
      //表格导出
      exportExcel("table", '分类分项报表', this.selectedDate);
    },
    handleCurrentChange (val) {
      this.getData(val);
    },
    handleSizeChange (val) {
      this.page.size = val;
      this.getData(1);
    },
  },
};
</script>
<style lang="scss" scoped>
@page {
  size: auto; /* auto is the initial value */
  margin: 0mm; /* this affects the margin in the printer settings */
}
.btn {
  background: #5fa4e8;
  color: #fff;
}
.black {
  color: #fff;
}
.report-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 14px;
  box-sizing: border-box;
  text-align: left;
  .content {
    display: flex;
    flex-flow: column;
    width: 100%;
  }
  .title-wrap {
    width: 100%;
    height: 50px;
    line-height: 40px;
    border-bottom: 1px solid rgb(214, 214, 214);
    margin-bottom: 14px;
    color: #000;
    display: flex;
    align-items: center;
    .title-content {
      font-weight: bold;
    }
  }
  .list1 {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    color: #000;
    .item {
      display: flex;
      align-items: center;
      border: 1px solid #5f5f5f;
      padding: 0px 6px;
      margin: 5px;
      .item-title {
        margin-right: 10px;
      }
    }
  }
}
.rows {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.addRow {
  margin-left: 67px;
  border: 1px dashed #797979;
  text-align: center;
  padding: 5px;
  margin-right: 87px;
  cursor: pointer;
}
.addRow1 {
  margin-left: 38px;
  border: 1px dashed #797979;
  text-align: center;
  padding: 5px;
  margin-right: 18px;
  cursor: pointer;
}
.maxHeight {
  max-height: 350px;
  overflow: auto;
}
.treeBox {
  max-height: 450px;
  overflow: auto;
}
.layou-container {
  overflow: none;
  text-overflow: none;
  white-space: "";
}
.verticalSave {
  margin-left: 262px;
  margin-top: 10px;
}
.mesureName {
  max-width: 200px;
  white-space: break-spaces;
  margin-right: 7px;
}
.time-warp {
  width: 100%;
  height: 100%;
  padding: 0px 10px;
  box-sizing: border-box;
  align-items: center;
  display: flex;
}
</style>